var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",class:_vm.fixedTop ?'fixedTop':''},[_c('pageHeader'),_c('router-view',{key:_vm.routerViewKey}),_c('pageFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }